import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CameraMessageDialog } from "../../../pages/app/technical-assessment/style";

const EnablingCameraMessageDialog = ({ open, message }) => {
  return (
    <CameraMessageDialog open={open}>
      <Box className="camera-header">
        <InfoOutlinedIcon />
        <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
          Interview Information
        </Typography>
      </Box>
      <Box className="camera-body">
        <Typography>{message}</Typography>
      </Box>
    </CameraMessageDialog>
  );
};

export default EnablingCameraMessageDialog;
